import styled from "styled-components";

export const HomePageWrapper = styled.div`
  margin: 45px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  height: calc(100vh - 65px);
`;

export const HomePageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0px 50px 0px;
`;

export const HeaderGreeting = styled.div`
  & > span {
    font-size: 30px;
    font-weight: 700;

    @media screen and (max-width: 576px) {
      font-size: 20px;
    }
  }
`;

export const HeaderTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px 0px 0px auto;
  /* width: 90px; */

  & > span {
    &:nth-child(1) {
      color: #ff5733;
      font-weight: 500;
      font-size: 20px;
      margin: 0px 0px 5px 0px;
      width: 85px;

      @media screen and (max-width: 576px) {
        font-size: 14px;
        width: 60px;
      }
    }

    &:nth-child(2) {
      color: ${function() {
        switch (localStorage.getItem("theme")) {
          case "dark":
            return "#bebebe";
            break;
          case "light":
            return "#858585";
            break;
          default:
            return "#858585";
        }
      }};
      font-size: 14px;
      width: 80px;

      @media screen and (max-width: 576px) {
        font-size: 10px;
        width: 55px;
      }
    }
  }
`;

export const HomePageMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const HomePageMenuHeaderStyled = styled.div`
  background-color: #ff5733;
  position: fixed;
  top: 0;
  width: calc(100% - 20px);
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
`;

export const LogoStyled = styled.div`
  & > span {
    color: ${function() {
      switch (localStorage.getItem("theme")) {
        case "dark":
          return "black";
          break;
        case "light":
          return "white";
          break;
        default:
          return "white";
      }
    }};
    font-weight: 700;
    font-size: 30px;
  }
`;

export const SettingsStyled = styled.div`
  & > button {
    border: none;
    outline: none;
    background: none;
    transition: transform 0.7s ease;

    & > span {
      color: ${function() {
        switch (localStorage.getItem("theme")) {
          case "dark":
            return "black";
            break;
          case "light":
            return "white";
            break;
          default:
            return "white";
        }
      }};
      font-size: 27px;
    }

    &:hover {
      transform: rotate(90deg);
    }

    @media screen and (max-width: 768px) {
      animation: spin 5s linear infinite;

      @keyframes spin {
        100% {
          transform: rotate(360deg);
        }
      }

      &:hover {
        transform: none;
      }
    }
  }
`;
